import React from 'react';
import Text from "@/components/marketing/Text";
import Section from '@/components/marketing/Section';
import { PresentationChart } from '@phosphor-icons/react';

interface CaseStudyHighlightProps {
    content: string;
};

const CaseStudyHighlight: React.FC<CaseStudyHighlightProps> = ({
    content = '',
}) => {
    return (
        <Section contentWidth="content-xs" padding="p-none" className="mx-auto mb-6 border-b border-dashed border-silvermist-100">
            <Section contentWidth="content-xxs" className="flex flex-col items-center gap-6">
                <div className='text-lupine-500'>
                    <PresentationChart size={24} weight='fill' />
                </div>
                <Text align="center" size="3xl" weight="semibold" tracking="tight" color="primary">{content}</Text>
            </Section>
        </Section>
    )
};

export default CaseStudyHighlight;